//
//
//
//
//
//
//
//
//

import * as util from "@/lib/util"
import Cookie from '@/lib/cookie.js'
export default {
  name: 'app',
	mounted() {
	  // 友盟统计添加
	  const script = document.createElement("script");
	  script.src = "https://v1.cnzz.com/z_stat.php?id=1278600141&web_id=1278600141";
	  script.language = "JavaScript";
	  document.body.appendChild(script);
	},
  watch:{
  '$route' (to, from) {
    let self=this;
    if( to.meta.title === '订单列表'){
      let domApp=document.querySelector('#app');
      domApp.scrollIntoView(10);
    }
		setTimeout(() => { //避免首次获取不到window._czc
		    if (window._czc) {
		        let location = window.location;
		        let contentUrl = location.pathname + location.hash + location.search;
		        let refererUrl = '/';
		        // 用于发送某个URL的PV统计请求，
		        window._czc.push(['_trackPageview', contentUrl, refererUrl])
		    }
		}, 300);
  }
},
  data () {
    return {
      user: {}
    }
  },
  created(){
    // if(!util.isOnline()){
    //    util.loadJS("https://oasisconst.oss-cn-beijing.aliyuncs.com/js/vconsole.min.js")
    // }
    if(!util.isOnline()){
      util.loadJS("https://cdn.bootcss.com/eruda/1.5.2/eruda.min.js").then(()=>{
        eruda.init()
      })
    }
   }
}



// WEBPACK FOOTER //
// ./src/App.vue